import { UserSchoolLicenseQueryDocument } from "@pathwright/graphql-client/src/generated"

export default UserSchoolLicenseQueryDocument
